import { Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";


interface contentBlocksInterface
{
    title: string
    icon: string
    text: string
}



const contentBlocks : contentBlocksInterface[] = [
    {
        title: "Who Am I",
        icon: "fa-user",
        text: `I'm Wilbroad Francis Mark — a highly experienced freelance software developer from Tanzania, specializing in both front-end and back-end web development, as well as mobile application development. 
With a strong foundation in real-world problem solving, I build scalable and user-focused solutions that deliver impact across web and mobile platforms.`,
    },
    {
        title: "Education",
        icon: "fa-graduation-cap",
        text: `Bachelor of Science in Software Engineering – [University of Dodoma (UDOM)](https://www.udom.ac.tz/). 
I've built a strong foundation in software design, distributed systems, and application development.`,
    },
    {
        title: "Tech Stack",
        icon: "fa-code",
        text: `Backend: Laravel, Spring Boot, Django\nFrontend: Angular, ReactJS, Vue.js, Next.js\nMobile: Flutter\nDatabases: MySQL, PostgreSQL, MongoDB\nDevOps: Docker, GitHub Actions, CI/CD Pipelines`,
    },
    {
        title: "Goals",
        icon: "fa-bullseye",
        text: `I'm working toward mastering Machine Learning and Deep Learning to integrate intelligent systems into mobile and web applications.`,
    },
];

const parseMarkdownLinks = (text: string) => {
    if (!text) return null;

    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts: (string | JSX.Element)[] = [];

    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
        const [fullMatch, linkText, url] = match;
        const start = match.index;

        if (start > lastIndex) {
            parts.push(text.slice(lastIndex, start));
        }

        parts.push(
            <a
                key={url + start}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-info text-decoration-none hover-underline"
                style={{ transition: "all 0.3s ease" }}
            >
                {linkText}
            </a>
        );

        lastIndex = start + fullMatch.length;
    }

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts;
};

const EducationTimeline = () => {
    const [visibleItems, setVisibleItems] = useState(1);

    useEffect(() => {
        const timer = setInterval(() => {
            setVisibleItems((prev) => (prev < contentBlocks.length ? prev + 1 : prev));
        }, 800);

        return () => clearInterval(timer);
    }, []);

    return (
        <Col
            md={12}
            className="px-4 d-flex flex-column justify-content-center timeline-container"
            style={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #0f172a, #1e293b)",
                overflowY: "auto",
                padding: "2rem"
            }}
        >
            <div className="timeline-line"></div>

            {contentBlocks.slice(0, visibleItems).map((block, index) => (
                <AnimatePresence key={index}>
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.1, duration: 0.5 }}
                        className="timeline-card mb-4 p-4 rounded-4"
                        style={{
                            background: "rgba(255, 255, 255, 0.05)",
                            borderLeft: `4px solid #3b82f6`,
                            position: "relative",
                            backdropFilter: "blur(10px)"
                        }}
                    >
                        <div className="d-flex align-items-center mb-3">
                            <div className="icon-container me-3">
                                <i className={`fas ${block.icon} fa-lg`} style={{ color: "#3b82f6" }}></i>
                            </div>
                            <h4 className="fw-bold text-white mb-0">{block.title}</h4>
                        </div>

                        { (
                            <p className="text-light mb-0" style={{ whiteSpace: "pre-line", lineHeight: "1.6" }}>
                                {parseMarkdownLinks(block.text)}
                            </p>
                        )}
                    </motion.div>
                </AnimatePresence>
            ))}
        </Col>
    );
};

export default EducationTimeline;